var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOneDoctor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "142.7px",
    height: "188.5px",
    viewBox: "55.3 30.5 142.7 188.5",
    enableBackground: "new 55.3 30.5 142.7 188.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2a8ae5",
    d: "M163.4,120.7l-36.7,36.7L90,120.7c-19.7,3.6-34.7,20.899-34.7,41.6V219H198v-56.7 C198.1,141.6,183.1,124.3,163.4,120.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#2a8ae5",
    cx: 126.7,
    cy: 71.2,
    r: 40.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "178.1,163.4 166.1,163.4 166.1,151.4 158.6,151.4 158.6,163.4 146.7,163.4 146.7,170.9  158.6,170.9 158.6,182.8 166.1,182.8 166.1,170.9 178.1,170.9  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDoctor);
export default __webpack_public_path__ + "static/media/one_doctor.c3bc2e1d104b91a086595a571fef24f9.svg";
export { ForwardRef as ReactComponent };